import React, { memo, useEffect } from "react";
import { useMutation, useNotify } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { SchoolIdSelected } from "utils/tools";
import { Button } from "@material-ui/core";
import { calculationCostStudentWidgetValidation } from "utils/validation";

interface CalculationCostStudentButtonProps {
  setResultCalculations: any;
  setIsLoaded: (isLoaded: boolean) => void;
  formData: any;
}

const useStyles = makeStyles({
  root: {
    marginLeft: 0,
  },
});

const CalculationCostStudentButton = ({
  setResultCalculations,
  setIsLoaded,
  formData,
}: CalculationCostStudentButtonProps) => {
  const schoolId = Number(SchoolIdSelected());
  const notify = useNotify();
  const classes = useStyles();

  useEffect(() => {
    setResultCalculations(null);
    setIsLoaded(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const [HandleCalculationCost, { loading }] = useMutation(
    {
      type: "create",
      resource: "CostPreview/registerStudent",
      payload: {
        data: {
          schoolId: schoolId,
          studentSchedule: {
            academicYearId: formData.academicYearId,
            startedAt: formData.date,
            isTaking: true,
            detail: {
              lat: formData.locationData?.LATITUDE,
              lng: formData.locationData?.LONGITUDE,
              street: formData.street,
              unitNumber: formData.unitNumber ? formData.unitNumber : null,
              blockNumber: formData.blockNumber,
              postalCode: formData.postalCode,
              building: formData.building,
              isMonday: formData.isMonday ? true : false,
              isTuesday: formData.isTuesday ? true : false,
              isWednesday: formData.isWednesday ? true : false,
              isThursday: formData.isThursday ? true : false,
              isFriday: formData.isFriday ? true : false,
              isFromSchool: formData.wayType === "OneWayMorning" ? false : true,
              isToSchool: formData.wayType === "OneWayAfternoon" ? false : true,
            },
          },
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultCalculations(res.json);
        setIsLoaded(true);
      },
      onFailure: (error) => {
        notify(`Failed Calculation Cost, error: ${error.message}`, "warning");
        setResultCalculations([]);
      },
    }
  );

  return (
    <Button
      className={classes.root}
      variant="contained"
      color="primary"
      onClick={HandleCalculationCost}
      disabled={calculationCostStudentWidgetValidation(formData)}
    >
      {loading ? `Loading...` : `Calculation Cost`}
    </Button>
  );
};

export default memo(CalculationCostStudentButton);
